import { AppThunk } from '../../../store/rootReducer';
import * as ecgActions from '../actions/ecg.actions';
import { getParentHolter } from '../clients/ecg.client';
import { HolterStripInfo, HolterStripPayload } from '../types/ecg.type';

export const loadStripInfo =
  (stripInfo?: HolterStripPayload): AppThunk =>
  async (dispatch) => {
    const dispatchHolterStrip = (holterStripInfo: HolterStripInfo | null) => {
      dispatch(
        ecgActions.update({
          update: { holterStripInfo },
          meta: { history: false },
        }),
      );
    };

    if (stripInfo == null) {
      return dispatchHolterStrip(null);
    }

    const parentHolter = await getParentHolter(stripInfo.parentId);

    if (parentHolter == null) {
      return dispatchHolterStrip(null);
    }

    return dispatchHolterStrip({
      ...stripInfo,
      parentDuration: parentHolter.duration,
    });
  };
